export default {
  isLogin({
    loginStatus
  }) {
    return !!loginStatus;
  },
  walletInfo({
    walletInfo
  }) {
    return walletInfo;
  },
  userInfo({
    userInfo
  }) {
    return userInfo;
  },
  safetyVerification({
    safetyVerification
  }) {
    return safetyVerification;
  }
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js